import styled from '@emotion/styled';
import * as React from 'react';
import { Z_INDEX } from '../../vars';
import { ScrollableContainer } from './ScrollableContainer';

export interface LayoutWidgetProps {
  staticHeader: React.ReactNode;
  staticFooter?: React.ReactNode;
  scrollableRef?: React.RefObject<HTMLDivElement>;
}

export const LayoutWidget: React.FC<React.PropsWithChildren<LayoutWidgetProps>> = (props) => {
  const { children, staticHeader, staticFooter, scrollableRef } = props;
  return (
    <S.Container>
      {!!staticHeader && <S.StaticHeader>{staticHeader}</S.StaticHeader>}
      <ScrollableContainer scrollableRef={scrollableRef}>{children}</ScrollableContainer>
      {!!staticFooter && <S.StaticFooter>{staticFooter}</S.StaticFooter>}
    </S.Container>
  );
};

namespace S {
  export const Container = styled.div`
    height: 100%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
  `;

  export const StaticHeader = styled.div`
    box-sizing: border-box;
    flex-shrink: 0;
    position: relative;
    z-index: ${Z_INDEX.STATIC_HEADER};
  `;

  export const StaticFooter = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;
    box-sizing: border-box;
  `;
}
